module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', [_c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    attrs: {
      "navigationEnabled": true,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#f58466',
      "paginationColor": '#999999',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 14
    }
  }, [_vm._l((_vm.props), function(slide) {
    return (_vm.props.length) ? [_c('slide', {
      staticClass: "column-slider"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('h3', [_vm._v(_vm._s(slide.headline.value))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(slide.text.value)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": slide.image.value[0].url,
        "alt": slide.headline.value
      }
    })])])])])] : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66a012f9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider-cases.vue
// module id = 1534
// module chunks = 0